import _ from "lodash";
import {
    _isBlank,
    flatArray,
    formatValue,
    getParentValue,
    parseFieldValue,
    toDate,
    wrapArray
} from "../components/utils";
import {Parser as FormulaParser} from 'on2air-formula-parser'
import {DateTime} from 'luxon';
import {convertTemplate} from "./templater";
import {storeFormField} from "./formPage";
export const findFieldAndValues = (store, path, match, initValues) => {
    let values = initValues
    let [fieldName,linkedFieldName = ''] = match.split('::')
    let parentMatch = 'parent.'
    let formPath = _.last(path)
    if(fieldName.includes(parentMatch)){
        const lastIndex = fieldName.lastIndexOf(parentMatch) + parentMatch.length
        const parentPath = fieldName.slice(0,lastIndex)
        const parentField = fieldName.slice(lastIndex)
        const [index,parentFormPath,parentValues,parentFieldValue] = getParentValue(path,store, parentPath, parentField)
        console.log('***findFieldAndValues*** parent', {fieldName,path,parentMatch,lastIndex,parentPath,parentField,formPath,parentFormPath,parentValues} )
        formPath = parentFormPath
        values = parentValues
        fieldName = parentField
    }
    const field = storeFormField( store, formPath, fieldName )
    console.log('***findFieldAndValues*** fields', {formPath, fieldName, field, linkedFieldName} )
    return [field,values,fieldName,linkedFieldName]
}
export const parseFormula = (store:any,mode:string,formula:string, path, initValues, config) => {
    const matches = [...formula.matchAll(new RegExp(/\{([^}]+)\}/, 'g'))]
    let parsed = formula
    const variables = {} as any
    for(let match of matches){
        const [fieldPlace,fieldNameFull] = match
        if(variables[fieldNameFull])continue;
        const [field,values,fieldName,linkedFieldName] = findFieldAndValues( store, path, fieldNameFull, initValues )
        console.log('**parseFormula**', {path, fieldNameFull, field, linkedFieldName, values, initValues})
        // const [fieldName,linkedFieldName = ''] = fieldNameFull.split('::')
        // const field = fields.find( f => [f.title,f.name].includes( fieldName) )
        const varName = `VAR_${_.size(variables) + 1}`
        const defVal = mode === 'number' ? 0 : ''
        parsed = parsed.replaceAll(fieldPlace,['hb','handlebars'].includes(config.parser) ? `{{${varName}}}` : varName)
        let fieldValue = _.get(values,field?.id)
        if([undefined,null].includes(fieldValue))fieldValue = _.get(values, field?.name || fieldName)
        fieldValue = parseFieldValue(field, fieldValue,linkedFieldName)
        if([undefined,null,''].includes(fieldValue) || (( _.isArray(fieldValue) || _.isPlainObject(fieldValue)) && _.isEmpty(fieldValue)))fieldValue = defVal
        variables[fieldNameFull] = {name:varName,value:fieldValue, field}

    }
    console.log('Parsing Formula', formula, parsed, variables, path)
    return {variables, parsed}
}


const flat = params => params.filter( p => !_isBlank(Array.isArray(p) ? flat(p) : p))
const arrayMath = (params, final = null, iter = null) => {
    let {items} = arrayParams(params,false, false)
    items = items.map( p => {
        const val = new Number(`${p || 0}`).valueOf()
        return iter ? iter(val) : val
    } )
    return final ? final(items) : items
}
const toAllArrays = params => _.map( params, param => flatArray(param) )
const arrayParams = (params, keepLast = true, skipEmpty = true) => {
    let items = []
    let last = null
    for(let x=0; x<params.length; x++){
        const param = params[x]
        if(Array.isArray(param)){
            items = items.concat(arrayParams(param, false, skipEmpty).items)
        }else if( x===0 || x < params.length -1 || !keepLast){
            if(param || !_isBlank(param) || !skipEmpty)items.push(param)
        }else{
            last = param
        }
    }
    console.log('arrayParams', items, params, keepLast, skipEmpty)
    return {items,last}
}
const functions = (config) => ({
    EMPTY_0: {
        set: params => {
            console.log('EMPTY_0 CALLED', params)
            params = flat(params)
            return params.length ? params : 0
        },
        on: null
    },
    EMPTY_BLANK: {
        set: params => {
            console.log('EMPTY_BLANK CALLED', params)
            params = flat(params)
            return params.length ? params : ''
        },
        on: null
    },
    JOIN: {
        set: params => {
            console.log("ARRAYJOIN",params)
            const {items,last} = arrayParams(params)
            return items.join(last || ", ")

        },
        on: null
    },
    SUM: {
        set: params => {
            console.log("ARRAYSUM",params)
            return arrayMath( params, items =>  {

                const s = _.sum(items)
                console.log("PERFORMING SUM ON ITEMS", items, params, s)
                return s
            })
        },
        on: null
    },
    MAX: {
        set: params => {
            console.log("ARRAYMAX",params)
            return arrayMath( params, items => Math.max(...items))
        },
        on: null
    },
    MIN: {
        set: params => {
            console.log("ARRAYMIN",params)
            return arrayMath( params, items => Math.min(...items))
        },
        on: null
    },
    AVERAGE:{
        set: params => {
            console.log("AVERAGE",params)
            return arrayMath( params, items => _.mean(items))
        },
        on: null
    },
    COUNT:{
        set: params => {
            console.log("COUNT",params)
            return _.size(
                _.filter(arrayParams( params, false, false).items, item => ![null,undefined,''].includes(item) && !isNaN(item))//
            )
        },
        on: null
    },
    AND:{
        set: params => {
            console.log("AND",params)
            return !_.find(
                arrayParams( params, false, false).items , item => _isBlank(item))
        },
        on: null
    },
    OR:{
        set: params => {
            console.log("OR",params)
            return _.find(
                arrayParams( params, false, false).items , item => !_isBlank(item))
        },
        on: null
    },
    XOR:{
        set: params => {
            console.log("XOR",params)
            const trueCount = _.countBy(arrayParams( params, false, false).items, _.isEmpty ).false || 0
            return (trueCount % 2) === 1
        },
        on: null
    },
    COUNTA:{
        set: params => {
            console.log("COUNT",params)
            return _.size(arrayParams( params, false, true).items )
        },
        on: null
    },
    COUNTALL:{
        set: params => {
            console.log("COUNT",params)
            return _.size(arrayParams( params, false, false).items )
        },
        on: null
    },
    CONCATENATE:{
        set: params => {
            console.log("CONCATENATE",params)
            return _.join(arrayParams( params, false, false).items, "" )
        },
        on: null
    },
    UNIQUE:{
        set: params => {
            console.log("UNIQUE",params)
            return _.uniq(arrayParams( params, false, false).items )
        },
        on: null
    },
    COMPACT:{
        set: params => {
            console.log("COMPACT",params)
            return arrayParams( params, false, true).items
        },
        on: null
    },
    FLATTEN: {
        set: params => {
            console.log("FLATTEN",params)
            return arrayParams( params, false, true).items
        },
        on: null

    },
    INCLUDES: {
        set: params => {
            console.log("FLATTEN",params)
            const {items, last} = arrayParams( params, true, true)
            return _.includes(items, last)
        },
        on: null

    },
    NTH: {
        set: params => {
            console.log("NTH",params)
            const {items, last} = arrayParams( params, true, false)
            return _.nth(items, last)
        },
        on: null

    },
    LAST: {
        set: params => {
            console.log("NTH",params)
            const {items, last} = arrayParams( params, false, false)
            return _.last(items)
        },
        on: null

    },
    FIRST: {
        set: params => {
            console.log("NTH",params)
            const {items, last} = arrayParams( params, false, false)
            return _.first(items)
        },
        on: null

    },
    REVERSE: {
        set: params => {
            console.log("NTH",params)
            const {items, last} = arrayParams( params, false, false)
            return _.reverse(items)
        },
        on: null

    },
    SORT_ASC: {
        set: params => {
            console.log("SORT_ASC",params)
            const {items, last} = arrayParams( params, false, false)
            return _.orderBy(items, _.identity, 'asc')
        },
        on: null

    },
    SORT_DESC: {
        set: params => {
            console.log("SORT_ASC",params)
            const {items, last} = arrayParams( params, false, false)
            return _.orderBy(items, _.identity, 'desc')
        },
        on: null

    },
    SAMPLE: {
        set: params => {
            console.log("SAMPLE",params)
            const {items, last} = arrayParams( params, false, false)
            return _.sample(items)
        },
        on: null

    },
    SAMPLE_SIZE: {
        set: params => {
            console.log("SAMPLE_SIZE",params)
            const {items, last} = arrayParams( params, true, false)
            return _.sampleSize(items, last)
        },
        on: null

    },
    SHUFFLE: {
        set: params => {
            console.log("SHUFFLE",params)
            const {items, last} = arrayParams( params, false, false)
            return _.shuffle(items)
        },
        on: null

    },
    INTERSECTION: {
        set: params => {
            console.log("INTERSECTION",params)
            const toSet = toAllArrays(params) as [any[]];
            return _.intersection(...toSet)
        },
        on: null

    },
    CHUNK: {
        set: params => {
            console.log("CHUNK",params)
            const {items, last} = arrayParams( params, true, true)
            return _.chunk(items, last)
        },
        on: null

    },
    DROP: {
        set: params => {
            console.log("DROP",params)
            const {items, last} = arrayParams( params, true, true)
            return _.drop(items, last)
        },
        on: null

    },
    DROPRIGHT: {
        set: params => {
            console.log("DROPRIGHT",params)
            const {items, last} = arrayParams( params, true, true)
            return _.dropRight(items, last)
        },
        on: null

    },
    UNION: {
        set: params => {
            console.log("UNION",params)
            const toSet = toAllArrays(params) as [any[]];
            return _.union(...toSet)
        },
        on: null

    },
    DIFFERENCE: {
        set: params => {
            console.log("DIFFERENCE",params)
            const toSet = toAllArrays(params) as [any[]];
            return _.difference(...toSet)
        },
        on: null

    },
    DATE_DIFF: {
        set: params => {
            console.log("DATE_DIFF",params)
            if(params.length >= 3 && _.isDate(params[0])  && _.isDate(params[1])){
                const d1 = toDate(params[0], config, true)
                const d2 = toDate( params[1], config, true )
                const units = params[2].split(',')
                const format = params.length >= 4 ? params[3] : ''
                const conversionAccuracy = params.length >= 5 ? params[4] : 'casual'
                const diff =  d1.diff( d2, units, {conversionAccuracy})
                return format ? diff.toFormat( format ) : diff.toHuman()
            }
            return ''
        },
        on: null
    },
    DATE_DIFF_NOW: {
        set: params => {
            console.log("DATE_DIFF_NOW",params)
            if(params.length >= 2 && _.isDate(params[0])){
                const d1 = toDate(params[0], config, true)
                const units = params[1].split(',')
                const format = params.length >= 3 ? params[2] : ''
                const conversionAccuracy = params.length >= 4 ? params[3] : 'casual'
                const diff =  d1.diffNow( units, {conversionAccuracy})
                return format ? diff.toFormat( format ) : diff.toHuman()
            }
            return ''
        },
        on: null
    },
    DATE_ADD: {
        set: params => {
            console.log("DATE_ADD",params)
            if(params.length){
                let date = params.shift()
                if(_.isDate(date)){
                    if(params.length) {
                        const dt = toDate(date,config, true)
                        const plus = {}
                        while(params.length) {
                            plus[params.shift()] = Number(params.shift())
                        }
                        console.log('Adding Date Before', dt.toLocaleString(DateTime.DATETIME_SHORT), plus)
                        const added = dt.plus(plus)
                        console.log('Adding Date After', added.toLocaleString(DateTime.DATETIME_SHORT), plus)
                        return added.toJSDate()
                    }
                    return date
                }
            }
            return ''
        },
        on: null
    }
})
const aliases = (fns) => ({
   ARRAY_JOIN: fns.JOIN,
   ARRAYJOIN: fns.JOIN,
    ARRAY_UNIQUE: fns.UNIQUE,
    ARRAYUNIQUE: fns.UNIQUE,
    ARRAY_COMPACT: fns.COMPACT,
    ARRAYCOMPACT: fns.COMPACT,
    ARRAY_FLATTEN: fns.FLATTEN,
    ARRAYFLATTEN: fns.FLATTEN,
    DIFF: fns.DIFFERENCE,
    SORT: fns.SORT_ASC,
    ORDER: fns.SORT_ASC,
    ORDER_ASC: fns.SORT_ASC,
    ORDERD: fns.SORT_DESC,
    ORDER_DESC: fns.SORT_DESC,
    SORTASC: fns.SORT_ASC,
    SORTDESC: fns.SORT_DESC,
    SORTD: fns.SORT_DESC,
    RANDOM: fns.SAMPLE,
    DATETIME_DIFF: fns.DATE_DIFF,
    DATETIME_ADD: fns.DATE_ADD,
    DATETIME_DIFF_NOW: fns.DATE_DIFF_NOW
})
const insertFormulas = ( parser, config ) => {
    const fns = functions(config)
    _.each(fns, (val, key) => {
        parser.setFunction(key, val.set)
    })
    const aFns = aliases(fns)
    _.each(aFns, (val, key) => {
        parser.setFunction(key, val.set)
    })

    parser.on('callFunction', function(name, params, done) {
        console.log('Formula Call Function', name ,params)
        if(functions[name] && functions[name].on){
            functions[name].on( params, done )
        }else if(aliases[name] && aliases[name].on){
            aliases[name].on( params, done )
        }
    });

}
export const calculateFormula = (env:string,store, mode:string,formula:string, path, values, config:any) => {
    const {variables,parsed} = parseFormula(store,mode,formula, path, values, config)
    let answer = {error:null,result:null, variables:[]}
    try {
        if(['hb','handlebars'].includes(config.parser)){
            const varData = {}
            _.each(variables, (item:any) => {
                varData[item.name] = item.value
            })
            const {output, error:hbError} = convertTemplate( {template:parsed, data:varData, format: config.format_as || 'text', output_format: config.render_as || 'text'})
            answer = {result:output, error: hbError, variables:variables}
        }else {
            const parser = new FormulaParser()
            insertFormulas(parser, config)
            _.each(variables, (item:any) => {
                parser.setVariable(item.name,item.value)
            })
            answer = parser.parse(parsed)
        }
    }catch(err){
        console.log('Formula Error', config.parser, err.message, err)
    }
    console.log('Formula Calculated', parsed, variables, answer, path, config)
    if(!answer.result && config.empty_msg)return {...answer, variables, result: config.empty_msg}
    const formatted = formatValue(env,answer.result, config)
    console.log('Formula Calculated Formatted', parsed, answer, formatted)
    return {...answer, result:formatted, variables}

}
